module.exports = __webpack_public_path__ + "static/media/content-1@768.5c8276bd.png";